import {all, call, put, takeEvery} from 'redux-saga/effects';
import {fetchMailsSuccess, showMailMessage} from 'actions/Mail';

import {FETCH_ALL_MAIL} from 'constants/ActionTypes';

const getMails = async () =>
{}


function* fetchMailRequest() {
  try {
    const fetchedMail = yield call(getMails);
    yield put(fetchMailsSuccess(fetchedMail));
  } catch (error) {
    yield put(showMailMessage(error));
  }
}


export default function* rootSaga() {
  yield all([takeEvery(FETCH_ALL_MAIL, fetchMailRequest)]);
}